import React from "react";
import { View, Grid, useTheme, TableRow, TableCell, Button, ThemeProvider, Table, TableHead, TableBody, Theme, Card, SelectField, Label, } from "@aws-amplify/ui-react";
import MiniStatistics from "../../components/ministatics/MiniStatistics";
import Productivity from "../../components/Productivity/Productivity";
import './Users.css';
import TitleSection from "../../components/titlesection/TitleSection";
const theme: Theme = {
    name: 'table-theme',
    tokens: {
        components: {
            table: {
                row: {
                    hover: {
                        backgroundColor: { value: '{colors.white.10}' },
                    },

                    striped: {
                        backgroundColor: { value: '{colors.white.10}' },
                    },
                },

                header: {
                    color: { value: '{colors.black.80}' },
                    fontSize: { value: '{fontSizes.sl}' },
                },

                data: {
                    fontWeight: { value: '{fontWeights.semibold}' },
                },
            },
        },
    },
};

const Users = () => {
    const { tokens } = useTheme();
    const productivityData = {
        title: "Productivity",
        totalHours: "20",
        days: "2.5",
        percentage: "2"
    }

    const label = [
        "Documentation",
        "Finance",
        "Automation",
    ]
    const trafficSourceData = [150, 120, 230]

    const colors = ["#2d8bba", "#6ce5e8", "#38b6ff"]

    return (
        <>
            <View className="user-detail-section">
                <div className="avatar">
                    <img alt="avatar" src={process.env.PUBLIC_URL + "/topperformers/users.png"}></img>
                    <div>
                        <h2>Alfredo</h2>
                        <h2>Rivera</h2>
                    </div>
                </div>
                <select>
                    <option>Alfredo Rivera</option>
                </select>
            </View>
            <TitleSection />
            <View borderRadius="6px" maxWidth="100%" padding="0rem" minHeight="100vh">
                <Grid
                    templateColumns={{ base: "1fr", large: "1fr 1fr" }}
                    templateRows={{ base: "repeat(1, auto)", large: "repeat(1, auto)" }}
                    gap={tokens.space.xl}
                >
                    <View>
                        <Grid
                            templateColumns={{ base: "1fr", large: "1fr 1fr" }}
                            templateRows={{ base: "repeat(2, auto)", large: "repeat(2, auto)" }}
                            gap={tokens.space.xl}
                        >
                            <View rowSpan={{ base: 1, large: 1 }}>
                                <MiniStatistics
                                    title="Conversation Sections"
                                    amount="150"
                                    percentage={"2"}
                                    progress={"1"}
                                    bgcolor={"#e2ffed"}
                                    textcolor={"#008425"}
                                />
                            </View>
                            <View rowSpan={{ base: 1, large: 1 }}>
                                <MiniStatistics
                                    title="Documents Accessed"
                                    amount="18"
                                    percentage={"2"}
                                    progress={"1"}
                                    bgcolor={"#fef0f9"}
                                    textcolor={"#ff5757"}
                                />
                            </View>
                        </Grid>

                        <Grid
                            templateColumns={{ base: "1fr", large: "1fr 1fr" }}
                            templateRows={{ base: "repeat(2, auto)", large: "repeat(2, auto)" }}
                            gap={tokens.space.xl}
                        >
                            <View rowSpan={{ base: 1, large: 1 }}>
                                <MiniStatistics
                                    title="Access Granted"
                                    amount="2"
                                    percentage={"2"}
                                    progress={"1"}
                                    bgcolor={"#f5f1fa"}
                                    textcolor={"#8c52ff"}
                                />
                            </View>
                            <View rowSpan={{ base: 1, large: 1 }}>

                                <MiniStatistics
                                    title="Tokens Generated"
                                    amount="609"
                                    percentage={"2"}
                                    progress={"1"}
                                    bgcolor={"#eef6ff"}
                                    textcolor={"#5271ff"}
                                />
                            </View>
                        </Grid>
                    </View>
                    <View>
                        <Productivity colors={colors} data={productivityData} label={label} trafficSourceData={trafficSourceData} />
                    </View>
                </Grid>
                <View >
                    <Grid>
                        <Card>
                            <Grid className="table-title click">
                                <View>
                                </View>
                                <View>
                                    <Label className="filtercss">Filter by</Label>
                                    <SelectField
                                        label=""
                                        size="small"
                                    >
                                        <option value="Date">Date</option>
                                    </SelectField>
                                </View>
                            </Grid>
                            <ThemeProvider theme={theme} colorMode="light">
                                <Table highlightOnHover variation="striped">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell as="th">Date / Time</TableCell>
                                            <TableCell as="th">Query</TableCell>
                                            <TableCell as="th">Action</TableCell>
                                            <TableCell as="th">Outcome status</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>25.07.2024 17:24</TableCell>
                                            <TableCell>Search for “P/E ratio” in document apple_earnings.pdf</TableCell>
                                            <TableCell>Search_text</TableCell>
                                            <TableCell><Button variation="primary" colorTheme="success" className="pass">Pass</Button>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>DD.MM.YYYY HH:MM</TableCell>
                                            <TableCell>Question 1:1 </TableCell>
                                            <TableCell>intent type</TableCell>
                                            <TableCell><Button variation="primary" colorTheme="error" className="fail">Fail</Button>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>DD.MM.YYYY HH:MM</TableCell>
                                            <TableCell>Question 1:1 </TableCell>
                                            <TableCell>intent type</TableCell>
                                            <TableCell><Button variation="primary" colorTheme="info" className="info"></Button>
                                            </TableCell>
                                        </TableRow>

                                    </TableBody>
                                </Table>
                            </ThemeProvider>
                        </Card>
                    </Grid>
                </View>
            </View>
        </>
    );
};

export default Users;
